export const WHOAMI_REQUEST = "Whoami.Request";
export const WHOAMI_SUCCESS = "Whoami.Success";
export const WHOAMI_FAILURE = "Whoami.Failure";

export function whoami() {
  return (dispatch, getState) => {
    const { auth } = getState();

    if (auth?.token) {
      dispatch({ type: WHOAMI_REQUEST });
      return fetch("/api/whoami", {
        headers: { Authorization: `Bearer ${auth.token}` },
      }).then(async (response) => {
        const data = await response.json();
        if (data.status === "success") {
          dispatch({
            type: WHOAMI_SUCCESS,
            payload: data.result,
          });
        } else {
          dispatch({ type: WHOAMI_FAILURE });
        }
      }).catch(() => {
        dispatch({ type: WHOAMI_FAILURE });
      });
    } else {
      dispatch({ type: WHOAMI_FAILURE });
    }
  };
}

export const LOGIN_REQUEST = "Login.Request";
export const LOGIN_SUCCESS = "Login.Success";
export const LOGIN_FAILURE = "Login.Failure";

export function login(credentials) {
  return (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    return fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        localStorage.setItem("token", data.result.token);
        dispatch({
          type: LOGIN_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: LOGIN_FAILURE,
          payload: data,
        });
      }
    });
  };
}

export const LOGOUT_REQUEST = "Logout.Request";
export const LOGOUT_SUCCESS = "Logout.Success";
export const LOGOUT_FAILURE = "Logout.Failure";

export function logout() {
  return (dispatch) => {
    dispatch({ type: LOGOUT_REQUEST });
    localStorage.removeItem("token");
    dispatch({ type: LOGOUT_SUCCESS });
  };
}

export const ACCOUNT_REQUEST = "Account.Request";
export const ACCOUNT_SUCCESS = "Account.Success";
export const ACCOUNT_FAILURE = "Account.Failure";
export const ACCOUNT_RESET = "Account.Reset";

export function account(id) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: ACCOUNT_REQUEST });
    return fetch("/api/account", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        localStorage.setItem("token", data.result.token);
        dispatch({
          type: ACCOUNT_SUCCESS,
          payload: data.result,
        });
        dispatch({
            type: LOGIN_SUCCESS,
            payload: { token: data.result.token },
        });
        dispatch(whoami());
      } else {
        dispatch({ type: ACCOUNT_FAILURE  });
      }
    });
  };
}

export function token() {
  return (dispatch) => {
    const token = localStorage.getItem("token");
    if (token) {
      const payload = token.split(".")[1];
      if (payload) {
        const data = JSON.parse(
          window.atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
        );
        if (Date.now() > data.exp * 1000) {
          localStorage.removeItem("token");
        } else {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: { token },
          });
        }
      } else {
        localStorage.removeItem("token");
      }
    }
    return Promise.resolve();
  };
}

export const LOGIN_RESET = "Login.Reset";

export function fileAuth(key) {
  return (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    return fetch("/api/auth/sign", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({key}),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        localStorage.setItem("token", data.result.token);
        dispatch({
          type: LOGIN_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: LOGIN_FAILURE,
          payload: data,
        });
      }
    });
  }
}

